import type { ReactNode, FC } from 'react';
import { Fragment } from 'react';
import { Button } from '@patternfly/react-core';
import { getLastLanguage } from '@console/app/src/components/user-preferences/language/getLastLanguage';

export interface ProgressiveListFooterProps {
  items: string[];
  onShowItem: (item: string) => void;
  Footer: FC<{ children?: ReactNode }>;
}

const ProgressiveListFooter: FC<ProgressiveListFooterProps> = ({ items, onShowItem, Footer }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const formattedString = new Intl.ListFormat(getLastLanguage() || 'en', {
    style: 'long',
    type: 'conjunction',
  }).format(items);

  let lastIdx = 0;
  let lastLen = 0;

  return (
    <Footer>
      <>
        {items.map((item) => {
          const currentIdx = formattedString.indexOf(item);
          const element = (
            <Fragment key={item}>
              {formattedString.slice(lastIdx + lastLen, currentIdx)}
              <Button variant="link" isInline onClick={() => onShowItem(item)}>
                {item}
              </Button>
            </Fragment>
          );

          lastIdx = currentIdx;
          lastLen = item.length;

          return element;
        })}
      </>
    </Footer>
  );
};

export default ProgressiveListFooter;
